<div
  id="modal-contain"
  [class]="'modal-container ' + modalData?.modal_type"
  [ngClass]="{
    'with-header': headState === 'portal2-state',
    off: !modalVisible || modalData?.modal_type === 'med-form',
    'hide-backdrop': modalData?.hide_backdrop,
    fullpage: modalData?.modal_style === 'fullpage'
  }"
>
  <div
    [class]="'card ' + modalData?.modal_type + ' ' + modalData?.modal_sub_type"
    [ngClass]="{
      off: !modalVisible || modalData?.modal_type === 'med-form',
      'with-header': headState === 'portal2-state',
      'with-side-menu': menuState === 'open-state'
    }"
  >
    <div
      class="modal-close"
      (click)="closeClick(modalData?.parent)"
      *ngIf="modalData?.modal_type !== 'exit'"
    ></div>

    <div *ngIf="modalData" class="inner">
      <ng-container *ngIf="modalData.modal_type === 'video-player'">
        <ng-container *ngIf="modalData.coming_soon">
          <div class="coming-soon-placeholder">Coming soon</div>
        </ng-container>
        <ng-container *ngIf="!modalData.coming_soon">
          <app-video-player
            [data]="modalData"
            [with_play_btn]="modalData.questionId"
          ></app-video-player>
        </ng-container>
        <!-- <app-video-player
          [data]="modalData"
          [download_link]="modalData.download_link"
          [with_play_btn]="modalData.questionId"
        ></app-video-player> -->
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'live-stream'">
        <app-live-stream [data]="modalData"></app-live-stream>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'slideshow'">
        <app-slideshow [data]="modalData"></app-slideshow>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'iframe'">
        <div class="iframe-container">
          <iframe [src]="iframeSource" class="iframe"></iframe>
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'pdf'">
        <div class="pdf-container">
          <div *ngIf="modalData.src" class="pdf-single">
            <ng2-pdfjs-viewer
              #pdfViewer
              id="pdfViewer"
              viewerId="pdf-viewer"
              *ngIf="showPdf"
              [pdfSrc]="modalData.src + '#0'"
              [fullScreen]="false"
              [print]="false"
              [viewBookmark]="false"
              [openFile]="false"
              [find]="false"
              [zoom]="modalData.zoom ? modalData.zoom : 'page-width'"
              [download]="!modalData.disallow_pdf_download"
              [downloadFileName]="modalData.download_file_name || undefined"
              [class.hide-user-controls]="modalData.hide_user_controls"
              (onDocumentLoad)="openExternalLinksInNewTab($event)"
            >
            </ng2-pdfjs-viewer>
          </div>
          <div *ngIf="modalData.src_set" class="pdf-slider">
            <a
              href="javascript:void(0);"
              class="nav-control left"
              (click)="prevPdfSlideClick()"
              >&#9664;</a
            >
            <a
              href="javascript:void(0);"
              class="nav-control right"
              (click)="nextPdfSlideClick()"
              >&#9654;</a
            >
            <div
              *ngFor="let src of modalData.src_set; let i = index"
              class="pdf-slide"
              [class.on]="i === currentPdfFileNumber"
            >
              <ng2-pdfjs-viewer
                #pdfViewer
                id="pdfViewer"
                viewerId="pdf-viewer"
                *ngIf="showPdf"
                [pdfSrc]="src + '#0'"
                [fullScreen]="false"
                [print]="false"
                [viewBookmark]="false"
                [openFile]="false"
                [find]="false"
                [zoom]="modalData.zoom ? modalData.zoom : 'page-width'"
                [download]="!modalData.disallow_pdf_download"
                [downloadFileName]="modalData.download_file_name || undefined"
                [class.hide-user-controls]="modalData.hide_user_controls"
                (onDocumentLoad)="openExternalLinksInNewTab($event)"
              >
              </ng2-pdfjs-viewer>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'image'">
        <div class="img-container">
          <img
            [src]="modalData.src"
            [ngClass]="{ hand: modalData.hotspots?.length }"
            [alt]="modalData.title"
            (click)="imageHotSpotClick($event)"
          />
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'sub-menu'">
        <h2
          class="title"
          *ngIf="modalData.title"
          [innerHTML]="modalData.title"
        ></h2>

        <div class="sub-menu-container">
          <div
            *ngFor="let item of modalData.menuItems"
            class="item"
            (click)="subMenuClick(item, modalData.id)"
          >
            <div>
              <div class="icon" [class]="item?.type"></div>
            </div>
            <span [innerHTML]="item.text"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'exit'">
        <img
          class="welcome-logo"
          src="../../../assets/images/takeda_logo.png"
        />
        <h2>Thank you for visiting our virtual exhibit.</h2>

        <p>
          Your feedback is Important to us!<br />
          Will you please take a moment to tell us about your experience.
        </p>

        <button class="modal-button" (click)="exitClick(true)">
          <span>YES</span>
        </button>
        <button class="modal-button" (click)="exitClick(false)">
          <span>NO</span>
        </button>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'thumbnails'">
        <h2
          class="title"
          *ngIf="modalData.title"
          [innerHTML]="modalData.title"
        ></h2>

        <div class="thumb-list">
          <div
            *ngFor="let thumb of modalData.menuItems"
            href="#"
            class="thumb"
            (click)="subMenuClick(thumb, modalData.id)"
          >
            <div class="img-container">
              <img [src]="thumb.image" />
              <div
                *ngIf="thumb.type === 'video'"
                class="play"
                (click)="subMenuClick(thumb, modalData.id)"
              >
                <div class="play-icon"></div>
                <span>PLAY</span>
              </div>
            </div>
            <p [innerHTML]="thumb.text"></p>
            <div
              *ngFor="let child of thumb.children"
              class="child-thumbs"
              (click)="subMenuClick(child, modalData.id)"
            >
              <div class="img-container">
                <img [src]="child.image" />
                <div
                  *ngIf="child.type === 'video'"
                  class="play"
                  (click)="subMenuClick(child, modalData.id)"
                >
                  <div class="play-icon"></div>
                  <span>PLAY</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          modalData.modal_type === 'html' ||
          modalData.modal_type == 'html-tak-sponsored'
        "
      >
        <h2 class="title">{{ modalData.title }}</h2>
        <div class="html-content" [innerHTML]="modalData.html"></div>
        <div class="footer">
          <div *ngIf="modalData.veeva_code" class="veeva-code">
            {{ modalData.veeva_code }}
          </div>
          <div *ngIf="modalData.showLogo" class="logo">
            <img
              src="data:image/png;base64,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"
              alt="Takeda"
            />
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'html-info'">
        <h2 class="title">{{ modalData.title }}</h2>
        <div class="html-content" [innerHTML]="modalData.html"></div>
        <div class="footer">
          <div *ngIf="modalData.veeva_code" class="veeva-code">
            {{ modalData.veeva_code }}
          </div>
          <!-- <div class="logo">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS4AAABsCAMAAADjea+iAAAAhFBMVEX////////////////////////////////////////////////////////////////////+8fH6xsj4qq32jZH0cXbxVFr94+T81Nb3m5/tHCTvOD/5uLruKTHwRkzzYmjwR03yVVvzY2n2jpL3nKD7x8n81df5ubv+8vL1gITuKjL1f4P3ztfCAAAAEXRSTlMAQICgwP/gYCBwsJBQ0PAQMOT1UzQAAApRSURBVHgB5NgJmqIwEAXgIaRY3A3ESNjBIE3f/3yzz2Cn6B00tP8J8H2vKonfTGBZFiHEpr/AJYf+QghxLcv7duc8yycL6sCbUbokK+v+grJcQtfwURtqkzsp29YiCwdGQZfu7kt3yh8hKZTZyvuKUREKU3Fs17uzqPaMsSD8hR/+C39jjIl7icxzFxt43pFFv/KRr4t/pZewPTxvvZz3qbnz1/AMwUJ+SOUHZHkYMHjGxl5tZ5rV0oFBLOIH+VlxHiYCBi3c2SXmDWd1DHgmBxRlVdcnpVSjl1ApFdQ1L0s5ID2EbD/7xLaDM8jCHA9fyeuzauFNlKofyg4P52MgBqdyHmGtFoAcIxRVXNVKwPu16sQLHFmCW+YsPfOHcAOafcJjvVP1uYVPUadK79khOoKOukYXi4JGRDmKSsE4RKBHFvMEDaWpFdv6Dsoq038OatUnNbU2mClOjBq4xTx781pWDw0g45TstcQcww5Ky9b2VZBPmBXSosQetT22IeYEZlHtHOSpvNRxBVMTJ+08iaO9drPwTAxrH2nfXQQtXEXDtc3PGTxhe2aFhYsleQPX075WMdszKazgoH1t3cKVqVLf+8KUwHb0xSmMA7iFhuv3VwaXbrT0PftJWGF6q7AQoQcWB7c+JbfkDR9oamDOtd9G7mb6sKYMjFo32vD4w7q6BQOoEgd2i52/tZ/sLKnhLRjiHL8U2IZcfQ7RgpelAnO0tdTECfTW00+kR6EX6GF1JzCLKOVL1wp74jOSQI9lUlO1YJxzJzW5uJjI1ZT30jX8J3Kp6c5goraSunAP/y0mKxjBG97wauGC4Z2/cSevFotRtQLADC7YQUxbMP+iWrnUFQKMduoGJnK6Dbal8F+USt0DmK4ppC5mUx2Rq02/4g9yDjseablEeF8wZzdeWktcLfMHEQkkkibwHxnrZrrG1cKPnhloOonkfcHoduRBHKiWPMF8tIVEUtZvfGu0QUQHIl5bM11g8rEvmD/eicjSgbQamJlaYtlxpCvYzoF/HiVWtDA7gRwQwT/r3Rj/1Yhs7mnhJ9Hwxt+sPv9GTPAg4kfinA9IGfcD6X/2T9NQDuDQ+8HNeXDNyQJR+OTbkN4oAopoevP//76vuTtnuCxO2PTc0961e3kGZlRe52VpMUTgoLfKXIjp8YsH5OkWtyjb0l5yK0yyvDpSmnYF9fW6XK7p4ovn+E+f397Jx9R2i+iTZX40XP4oHtN0OEL2dvgvqJO3WXRL598FLtJH4AtT1mcv+odEBAfd6oFr/kXgwngEjbcMkPeJm6HtVhdc6YfBtVD79PoFt3a/361luqZXOPuJK5FDhin8KLgstk+vX4smvzrTrVi7JWanhjazuOqHwJXw7P1+xa6E4kRu5X63lJfD72fDRfowXVXu8euEQ2JXVR2/H1zRxC64OswFZSv7Vbk1dbhFGr4LXNH5vB91CB1wyfo0XRf6dZNbcrOF5nbRmJ0O43YZBOKywLpdM310noQL0DSYNOC6DDXR7ILmvdmvEz6uQb1RPXDhV/Z5CBpDby7zJLPAQzubjzO4sJ33SGMJF517P8BqaRhKR89XiXXZr8eS6a9VL1z4lY4vLweScL3BS63gj+sDw9cvFVxhyGxHD6shve/16z661TEoIlz47AcVMQkvSHLVE9zsfT7/pZSQRdMWLssp8/tJ9qvfLezmZbjwhpIHRBCu4DHzscXz9BnvlhX/nqeIjifZYvf7VvTrr1638DwyXHjFPioVEh3KAFwLqzwdgclLX/q5VplOdppbmzWkjUNUamTsgQbRr/vtZxDtvV+pXrj0Ui6xTbiSTYAW3S/ljWvp9AxpuCe7YW+Dq0EfU79f5NY2tfSuGy4P/oUaLlAeFYm8jtxrT2ZCkecKuDTzGlej3k2iXy8az07t1FLqhsvhglDD1f6MyF2lJQcAN2nY3tGRyS1cjUqiX/D8667o1vRJhAvaL1I/jZ2RbcGlmDI1E3crYhBQ7K787GOVpQ0Il5zck7v4PPoE93NDLIbqDB7bX22tYOX3jg1n0a3ibBva64pQXJGgraPWLpr2LgyKdFENhU64TD2g5jZctAZgmTJL3pbAjAZYZr7AVRdtcAHmXqJfj7GbD3k6UC9cdL8ATAMubHvGR1ix27H1Dp4WMLgGWE0LQNOBiOgnZTcPaR2qEy5djS5ahIvGALZ7cisOAywKIhoYCjdnGS7BLvKLuvsT4XC7XbqCa64CbG3Ble1YncQczB7QC14UBcZQtp2+7JFodZ9dlKpQd3+fRtq2kmSXA7jYEnN9JNcb+z5BV7SY62aBWxkXhTJjw44wHNiVp1owYJxYfmpSezT9r7k+HsGVAS5m1wzdjYbqd+b3Y680eB6iArdItIjTExG+oYh1vbpreSqFw8Enmff5525biy3tKJGQ4cJFK5Ta/3vHiuPCzK2eqAwfV8wFBYZKbbIrDLBa++JSxjzlUNuVqHM4+B7zKX0wf/CwZVaWNbwMF8T2ZozLDFW3JbxhFbjd85BblX38H8NE67M1M7MnOTcUvY5RwWX20+ztMNQPJbwKLbRIj5+X0zH0ev19vYFTCHBRVy/LQ4GY1rqRz8Go5205N/c6yZLHOtLrnWt3jNa9O/Rm8QiwsA98qQMuWiiJ0Bmr63T8/rz3mU1JtEIbCKuxx/+8v+7XSURr1xFgw6WEeN8DFxiQR1f83LBuj/DvMkLDk+w0wUgxNhc/fVS+PHeCGaCgD5dOwcpoHQJGFqxQY0twwYOzIfAcPlk9AFzcgLTF1li9WF0nE2NRva0G6pNNK3M8q36gQXQpba7REgFzhMrnjzJchc6NvrhAucP530UFhIvGr8XxfoX/Y7m8jqF+YbJa/gokbaGcT59c4MYPplW/LVW250OFVguwMYMFgaMAiuasePUNIPMQt6mPc/UlonUzHabcPuKp+O/RGVY3jW40zW/HKTC8jBbpzr16NotjsZLUHyd6dXaJfwktruePETCKr5Feyv5pGqCQbaMlA+aKAP8c1B+nd+UgZWS0DgDTZSO8/vNCMVEhu8s30ZIBG/E7t7d/XihCUWS+HK1/ursKJddhILYO47rvHQyUmf7/+45BiY/CWas0UNQYtZWMDQwBIsjBLrZ2WF4qIdVVLYymvHyxiq8bY3ldrWm9QSeFV+Jy9HKwjq0F/s6qTctoYLmCtRc6PqVjW5RwU6d+UgI0sJBcFMRtWX6dNsV9K+uokQn0rYGxJs1F2WC1t6AjXkqVqpgoMZtW5QbmQvnjBiUGwQD1+w6q1Kqhvzjktz+fJIa4s+46bLf7wGNki19IChrmu0RejqXbol1vs92fxFF1PK++skwpekbcOD0oenvgb9TWtSSsjBScqn6p5g5HsbiiW6obvlDJFA3UHZCtDviygDCsjIfUCXSOMvpScMPCXHZW1BXS0kFJ93N5VJWOFPIi6g4qMCsPt2IwM1y7HHedJM6+PXCj3nLq5aOnWHHtBPK5YndCvSFzZffJ/k8kVKknk6o8HeqE0EnmOJ4gpE6oqAkeAfmfoHIp9o5IAAAAAElFTkSuQmCC"
              alt="Takeda"
            />
          </div> -->
        </div>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'component'">
        <app-dynamic-components-loader
          [modalData]="modalData"
        ></app-dynamic-components-loader>
      </ng-container>

      <ng-container
        *ngIf="
          modalData.modal_type === 'default' || modalData.modal_type === ''
        "
      >
        <h2>{{ modalData.title }}</h2>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'upcoming_events'">
        <div
          class="upcoming-events"
          *ngIf="modalData.modal_sub_type === 'showcase_1'"
        >
          <div class="upcoming-main">
            <div class="event-group">
              <h2>Saturday, May 22</h2>
              <div class="events-list">
                <div class="event-item">
                  <div class="event-time"><span>2:30pm-3:15pm EST</span></div>
                  <div class="event-copy">
                    <div class="copy">
                      Breaking Down a Landmark Study in Moderate to Severe UC
                    </div>
                    <div class="register">
                      <a
                        href="https://www.programrsvp.com/GAS-122"
                        (click)="externalLink($event, '')"
                        target="_blank"
                        rel="noopener nofollow"
                        >Register Here</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="event-group">
              <h2>Sunday, May 23</h2>
              <div class="events-list">
                <div class="event-item">
                  <div class="event-time"><span>9:15am-10:00am EST</span></div>
                  <div class="event-copy">
                    <div class="copy">
                      Could It Be SBS? Properly Identifying and Managing
                      Patients with Short Bowel Syndrome (SBS)
                    </div>
                    <div class="register">
                      <a
                        href="https://www.programrsvp.com/GAS-123"
                        (click)="externalLink($event, '')"
                        target="_blank"
                        rel="noopener nofollow"
                        >Register Here</a
                      >
                    </div>
                  </div>
                </div>
                <div class="event-item">
                  <div class="event-time"><span>12:15pm-1:00pm EST</span></div>
                  <div class="event-copy">
                    <div class="copy">
                      Hear a Leading Expert Discuss a Treatment for Moderate to
                      Severe CD
                    </div>
                    <div class="register">
                      <a
                        href="https://www.programrsvp.com/GAS-102"
                        (click)="externalLink($event, '')"
                        target="_blank"
                        rel="noopener nofollow"
                        >Register Here</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upcoming-footer upcoming-footer-1">
            <div class="footer1">
              <img
                src="../../../assets/images/ddw/upcoming/footer-spacer-fs8.png"
                class="footer1-img-1"
              />
              <img
                src="../../../assets/images/ddw/upcoming/view-disease-awareness-fs8.png"
                class="footer1-img-2"
                (click)="openModal('upcoming_events_2')"
              />
            </div>
            <div class="footer2">
              <img
                src="../../../assets/images/ddw/upcoming/creating-better-future-fs8.png"
                class="footer2-img-1"
              />
            </div>
          </div>
        </div>
        <div
          class="upcoming-events"
          *ngIf="modalData.modal_sub_type === 'showcase_2'"
        >
          <div class="upcoming-main">
            <div class="event-group">
              <h2>Sunday, May 23</h2>
              <div class="events-list">
                <div class="event-item">
                  <div class="event-time"><span>11:30am-12:15pm EST</span></div>
                  <div class="event-copy">
                    <div class="copy">
                      See EoE: A Multidisciplinary Approach to Diagnosing and
                      Managing Eosinophilic Esophagitis
                    </div>
                    <div class="register">
                      <a
                        href="https://www.programrsvp.com/GAS-125"
                        (click)="externalLink($event, '')"
                        target="_blank"
                        rel="noopener nofollow"
                        >Register Here</a
                      >
                    </div>
                  </div>
                </div>
                <div class="event-item">
                  <div class="event-time"><span>2:30pm-3:15pm EST</span></div>
                  <div class="event-copy">
                    <div class="copy">
                      CDPATH™ a Personalized Prognostic Tool for Crohn's Disease
                    </div>
                    <div class="register">
                      <a
                        href="https://us02web.zoom.us/webinar/register/WN_jVFch7OVSvCk1RxGyWIYXg"
                        (click)="externalLink($event, '')"
                        target="_blank"
                        rel="noopener nofollow"
                        >Register Here</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upcoming-footer upcoming-footer-2">
            <div class="footer1">
              <img
                src="../../../assets/images/ddw/upcoming/go-back-spacer-fs8.png"
                class="footer1-img-1"
              />
              <img
                src="../../../assets/images/ddw/upcoming/go-back-fs8.png"
                class="footer1-img-2"
                (click)="openModal('upcoming_events')"
              />
            </div>
            <div class="footer2">
              <img
                src="../../../assets/images/ddw/upcoming/creating-better-future-fs8.png"
                class="footer2-img-1"
              />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          modalData.modal_type === 'default' || modalData.modal_type === ''
        "
      >
        <h2>{{ modalData.title }}</h2>
      </ng-container>

      <ng-container *ngIf="modalData.modal_type === 'disease_education'">
        <div class="disease-education">
          <div class="de-logo">
            <img
              class="welcome-logo"
              src="../../../assets/images/takeda_logo.png"
            />
          </div>
          <div class="de-main">
            <div class="de-main-inner">
              <div class="de-entry">
                <div
                  class="de-headline"
                  (click)="externalLink($event, 'https://www.cdpath.com', 'Learn More About CDPATH a Personalized Prognostic Tool for Crohn’s Disease')"
                >
                  <div class="de-title">
                    Learn More About CDPATH a Personalized Prognostic Tool for
                    Crohn’s Disease
                  </div>
                </div>
                <div
                  class="de-link"
                  (click)="
                    externalLink(
                      $event,
                      'https://players.brightcove.net/2574028764001/HyzZShG2W_default/index.html?videoId=6256753032001',
                      'Access CDPATH Discussion'
                    )
                  "
                >
                  <span>Access CDPATH Discussion</span>
                </div>
              </div>
              <div class="de-entry">
                <div
                  class="de-headline"
                  (click)="
                    externalLink($event, 'https://www.eoevirtualbooth.com', 'Learn about Eosinophilic Esophagitis (EoE) including', 'Diagnosis and Management')
                  "
                >
                  <div class="de-title">
                    Learn about Eosinophilic Esophagitis (EoE) including
                    Diagnosis and Management
                  </div>
                </div>
                <div
                  class="de-link"
                  (click)="
                    externalLink(
                      $event,
                      'https://us02web.zoom.us/j/86291433486?pwd=Qm5saWZyME5mMG95eE9peFVSL1FVQT09',
                      'Join Us in our Virtual Presentation Theater'
                    )
                  "
                >
                  <span>Join Us in our Virtual Presentation Theater</span>
                </div>
              </div>
            </div>
          </div>
          <div class="de-disclaimer">
            This booth is intended for Healthcare Professionals Only.
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div
    class="background-close"
    (click)="closeClick(modalData?.parent)"
    [ngClass]="{ on: modalVisible }"
  ></div>
</div>
